export const environment = {
    production: true,
    tenant: 'vivacom',
    apiServerUrl: `/api-server`,
    loginToken: '44aa350e-b43d-42a9-ae11-44de28aaa628',
    firebase: {
        apiKey: "AIzaSyDH6IucWuo-rRAs69sDmlQwx-Od1Hk1ROc",
        authDomain: "angie-iot-prod-d57ba.firebaseapp.com",
        projectId: "angie-iot-prod-d57ba",
        storageBucket: "angie-iot-prod-d57ba.appspot.com",
        messagingSenderId: "512013221922",
        appId: "1:512013221922:web:4b4437ff3fb25f7b14ca7b",
        measurementId: "G-TLMLNVKTES"
    },
    mapTilesAddress: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    sentry: {
        enabled: true,
        environment: 'production',
    }
};
